import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from '@lyse-as/formds-react';
import { OpenInNewIcon } from '@lyse-as/formds-react/lib/icon/common';

import { getAnonymizedCurrentPageUrl, GtmElementCategory, GtmElementCta } from 'app/utils/gtm-tracking-utils';
import { getDataLayers } from 'app/utils/trackingService';

import styles from './invoice-avtalegiro.module.scss';

export enum NetsAvtaleType {
  AvtaleGiro = 'avtalegiro',
  eFaktura = 'efaktura',
  AvtaleGiroAndEFaktura = 'combination',
  None = 'none',
}

interface Props {
  paymentAgreement: MinesiderBackend.PaymentAgreement;
  returnUrl: string;
  netsAvtaleType: NetsAvtaleType;
  disableSubmitButton: boolean;
  children?: React.ReactNode;
}

export const NetsAvtaleGiroForm = ({ paymentAgreement, returnUrl, netsAvtaleType, children }: Props) => {
  const { t } = useTranslation();
  const [submitButtonIsLoading, setSubmitButtonIsLoading] = useState(false);

  const formSubmitted = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitButtonIsLoading(true);

    getDataLayers().customEvents.pushButtonClickEvent({
      element_category: GtmElementCategory.AVTALEGIRO,
      element_cta: GtmElementCta.INVOICE_CREATE_AVTALEGIRO_CONTINUE,
      element_url: paymentAgreement.baseUrl,
      page_url: getAnonymizedCurrentPageUrl(),
    });

    const form = e.target as HTMLFormElement;
    form.submit();
  };

  return (
    <form action={paymentAgreement.baseUrl} method="post" onSubmit={formSubmitted}>
      {children}
      <input type="hidden" name="companyName" id="companyName" value={paymentAgreement.companyName} />
      <input type="hidden" name="returnUrl" id="returnUrl" value={returnUrl} />

      {(netsAvtaleType === NetsAvtaleType.AvtaleGiro || netsAvtaleType === NetsAvtaleType.AvtaleGiroAndEFaktura) && (
        <>
          <input
            type="hidden"
            name="companyAccountNo"
            id="companyAccountNo"
            value={paymentAgreement.companyAccountNo}
          />
          <input type="hidden" name="kid" id="kid" value={paymentAgreement.kid} />
        </>
      )}
      {netsAvtaleType === NetsAvtaleType.AvtaleGiro && (
        <Button
          variant="filled"
          scheme="primary"
          type="submit"
          className={styles.avtaleGiroButtonContinue}
          disabled={submitButtonIsLoading}
        >
          {submitButtonIsLoading ? (
            <span style={{ display: 'inline-flex', width: '1.25em', height: '1.25em' }}>
              <Spinner loadingText="Laster" loadingCompleteText="Ferdig" isLoadingComplete={false} />
            </span>
          ) : (
            <>
              {t('pages.invoice.invoiceAvtaleGiro.avtaleGiroButtonContinue')}
              <OpenInNewIcon />
            </>
          )}
        </Button>
      )}
    </form>
  );
};
